<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid"
                                                                                               :src="`${publicPath}app-assets/images/pages/busmen.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;bottom: 79%;left: 4%;">
                <h3 class="text-white cursiveFont">Conquer The Market!</h3>
                <h3 class="text-white cursiveFont">Fast And Secure Payments</h3>
                <p class="text-white mb-0 ">Cheaper payments with free services</p>
                <p class="text-white mb-0 ">Industry low fees and no hidden charges.</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Sign up your account! 👋</h3>
                <Form class="auth-login-form mt-2" @submit="sendCall" v-slot="{ errors }" :validation-schema="schema" :initial-values="{email: email}">
                  <p v-if="Object.keys(errors).length" class="card-text mb-2 text-danger">{{ errors[Object.keys(errors)[0]] }}</p>
                  <div class="form-group">
                    <label class="form-label">First Name</label>
                    <Field type="text" name="firstName" class="form-control" v-model="firstName" placeholder="First Name"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Last Name</label>
                    <Field type="text" name="lastName" class="form-control" v-model="lastName" placeholder="Last Name"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Business Name</label>
                    <Field type="text" name="businessName" class="form-control" v-model="businessName" placeholder="Business Name"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" placeholder="Email" v-model="email" disabled/>
                  </div>
               
                  <div class="form-group">
                    <label class="form-label">Password</label>
                    <div class="input-group form-password-toggle">
                      <Field name="password" class="form-control" :type="showPassword?'text':'password'" placeholder="Password"
                        v-model="password" />
                      <div class="input-group-append">
                        <span  class="input-group-text cursor-pointer" @click="()=> showPassword = !showPassword">
                          <BIconEyeFill v-if="!showPassword"  />
                          <BIconEyeSlashFill v-else  />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Confirm Password</label>
                    <div class="input-group form-password-toggle">
                      <Field name="confirmPassword" class="form-control" :type="showConfirmPassword?'text':'password'" placeholder="Confirm Password"
                           v-model="confirmPassword"/>
                      <div class="input-group-append">
                        <span  class="input-group-text cursor-pointer" @click="()=> showConfirmPassword = !showConfirmPassword">
                          <BIconEyeFill v-if="!showConfirmPassword"  />
                          <BIconEyeSlashFill v-else  />
                        </span>
                      </div>
                    </div>
                   
                  </div>
                  <div class="form-group">
                    <label class="form-label">Contact Info</label>
                    <vue-tel-input :value="phone" @input="onInput" ></vue-tel-input>
                    <small class="text-danger" v-show="phoneError">*Phone Field is required</small>
<!--                    <div class="row">-->
<!--                      <div class="col-4">-->
<!--                        <Field type="text" name="carrierCode" class="form-control" v-model="carrierCode"-->
<!--                               placeholder="Code"/>-->
<!--                      </div>-->
<!--                      <div class="col-8">-->
<!--                        <Field type="text" name="phone" class="form-control" v-model="phone" placeholder="Phone"/>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                  <div class="form-group">
                    <label class="form-label">Referral Code</label>
                    <Field type="text" name="referralCode" class="form-control" v-model="referralCode" placeholder="Referral Code (optional)" :disabled="referralLocked"/>
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Sign up</Button>
                  </div>
                </form>
                <p class="text-center mt-2"><a @click="$router.push({name:'send-otp'})" href="javascript:void(0)"><span>Want To Change Your Email?</span></a></p>
                <p class="text-center mt-2"><span>Already have an account?</span><a @click="goToLogin" href="javascript:void(0)"><span> Go to Login</span></a></p>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.applyReferralCode()
    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'send-otp'});
      }
    } else {
      this.email = this.$route.params.email
    }
  },
  data() {
    return {
      showPassword:false,
      showConfirmPassword:false,
      loader: false,
      firstName: '',
      lastName: '',
      businessName: '',
      email: '',
      password: '',
      confirmPassword: '',
      carrierCode: '',
      phone: '',
      referralCode: '',
      referralLocked: false,
      userType: 'merchant',
      phoneDetails: {
        countryCallingCode: "",
        formatted: "",

      },
      phoneError:true



    }
  },
  methods: {
    // Prepopulate (and lock) the referral code when the user arrived via a ?ref=CODE link.
    // The router interceptor stores it in sessionStorage so it survives the auth redirects.
    applyReferralCode() {
      let ref = this.$route.query.ref
      if (typeof ref !== 'string' || ref.trim() === '') {
        ref = sessionStorage.getItem('referralCode')
      }
      if (ref && ref.trim() !== '') {
        this.referralCode = ref.trim()
        this.referralLocked = true
      }
    },
    onInput(phone, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.phoneDetails = phoneObject
        if(typeof(this.phoneDetails.valid) == "undefined"){
          this.phoneError = true
        }else{
          this.phoneError = false
        }

      }
    },
    goToLogin() {
      this.$router.push({name: 'login'});
    },
    sendCall() {
      if(this.phoneError){
        return
      }
      let data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword,
        carrierCode: this.carrierCode,
        businessName: this.businessName,
        phone: this.phone,
        referralCode: this.referralCode,
        type: this.userType,
      }

      if(typeof(this.phoneDetails.valid) != "undefined"){
        data.phone = this.phoneDetails.nationalNumber
        data.carrierCode = this.phoneDetails.countryCallingCode
      }

      this.loader = true
      this.makeRequest('post', 'v1/register', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            sessionStorage.removeItem('referralCode');
            this.$router.push({name: 'set-passcode'});
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });
    },
  },
}
</script>
<style scoped>
.input-group .form-control {
  border-right: 1px solid lightgray;
}

</style>

